const sponsorConfig = {
  oldSponsorInfo: 'Use Last Year’s Ad Spot',
  infoFromPartner:
    'I will provide the information needed to create the ad spot.',
  infoFromSponsor:
    'Please contact my sponsor to get the information needed for creating the ad spot',
  choosePreviousSponsor:
    'You can either choose a previous sponsor from the list (or)',
  addNewSponsor: 'Click "Add New Sponsor" to add a new sponsor',
  existingSponsorDialogTitle:
    'Choose an existing Sponsor Commercial (or) Add New',
  overrideSponsorConfirmTask:
    'Are you sure you want to skip Sponsor Approval and send this script directly to the Message Creator',
};

export default sponsorConfig;

export const musicConfig = {
  reAddTrackSuccess:
    'Selected tracks have been re-added to the library. Tracks will be available in the player after the next sync',
  songSetDeleteWarning: (songSetName: string, hasMusicSchedule: boolean) =>
    `The song set "${songSetName}" must be removed ${
      hasMusicSchedule
        ? 'from the following schedule(s)'
        : 'from the following event music mix(es) in Radio Mode'
    } before it can be deleted.`,
};

export const tnnSponsorConfig = {
  requestCompanySelection: 'Please select a company',
  noSchoolWarning: 'No school available for the selected company',
};

export const excludePartnerConfirmMessage = {
  title: 'Are you sure you want to Exclude this task?',
  body: 'The associated partner will be added to the exclusion list and their data will no longer appear in Download Management.',
};

export const quickLaunchConfig = {
  addMessage: `Messaging is only available for Level 1 and Level 2 Partners. If you are interested in upgrading your account, please contact your Partner Success Manager, who can assist you.`,
};

export const alertMessageConfig = {
  fileNameWithoutZZZ: 'File name must not contain "zzz"',
  mp3_format_error: 'Please upload a valid mp3 file',
};

export const alertConfig = {
  mp3_format_error: 'Please upload a valid mp3 file',
  form_expired_invalid_token:
    'Form Expired, Since the coach already selected the song.',
};

export const songRequestRejectedMessage =
  'This song was rejected.  Please select a new song.';

export const tnnDemographicsConfig = {
  download_sample: 'Download Sample File',
  gt_download_pop_up:
    'GameTime Partners: (Person/Men/Women) per events are required to calculate Total (Person/Men/Women)',
  non_gt_download_pop_up:
    'Non-GameTime Partners: Total (Person/Men/Women) are required to calculate (Person/Men/Women) per events',
};

export const followUpMessageConfig = {
  followUpMessageTitle: 'Follow Up Details',
  followUpNotesUpdated: 'Follow-up notes updated successfully',
  followUpNotesUpdateFailed: 'Failed to update follow-up notes',
};
export const stationDeactivationConfig = {
  remainderSet: 'One or more stations have remainder set',
  remainderOverdue: 'One or more stations have overdue remainder',
};

export const fileVerificationConfig = {
  reset_message: 'Are you sure you want to reset the file:',
  reset_message_2: 'This will remove the uploaded file and reset the status.',
};

export const hotkeyDuplicationConfig = {
  title: ' Replace Hot Key Assignment?',
  message: 'Proceeding will replace the existing track with the current one.',
};
export const radioGenresConfig = {
  zeroPercentNotAllowed: 'Genre with 0% is not allowed',
  selectionMustBe100: 'Selection must be 100%',
  songSetNameTaken:
    'This Song Set name is already taken, please enter a unique name',
};

export const trackAvailabilityConfig = {
  no_tracks: 'No tracks available.',
};

export const songSetConfig = {
  insufficient_tracks:
    'Insufficient songs in this Song Set (minimum 10 required).',
};
